mutation RestoreUsers($ids: [ID!]!) {
  restoreUsers(ids: $ids) {
    id
    deletedAt
  }
}
